<template>
  <div>
    <CreateSurveyForm 
      v-if="isMissingSurvey"
      :projectId="project.projectId"
      :surveyId="project.survey.surveyId"
      @showOverviewTab="showOverviewTab"
      @refreshSurveyTabAfterCreate="refreshSurveyTabAfterCreate"
    ></CreateSurveyForm>
    <BaseMessageBlock :messages="uniqueErrors"></BaseMessageBlock>
    <b-modal
      ref="question-type-modal"
      title="Add Question"
      ok-title="Create New"
      cancel-title="Question Template"
      cancel-variant="primary"
      @cancel="showQuestionTemplateModal"
      @ok="showNewQuestionModal"
    >
      <p>Do you want to use a question template or create a new question?</p>
    </b-modal>
    <b-modal
      ref="new-question-modal"
      title="Create Question"
      ok-title="Create"
      @ok="createQuestion"
    >
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import ProjectActionBar from "@/sub-components/ProjectActionBar.vue";
import CreateSurveyForm from "@/components/survey/CreateSurveyForm.vue";

export default {
  name: "CreateSurvey",
  components: {
    ProjectActionBar,
    CreateSurveyForm,
  },
  props: {
    project: { type: Object, required: true },
    survey: { type: Object, default: null },
  },
  data() {
    return {
      errors: [],
      dataLoaded: false,
      loading: false,
      waiters: {
        sending: false
      },
      questionTemplates: [],
      questionFields: [
        { key: "question_checkbox", label: "" },
        { key: "text", label: "Question", sortable: true }
      ],
      questionSearchFilter: ""
    };
  },
  mounted() {
    if (this.survey === null) {
      this.survey = {
        surveyId: "",
        projectId: this.project.projectId,
        surveyName: this.project.projectName,
        surveyType: "Project Survey",
        questions: [],
        hasQuestions: false,
      };
    }
  },

  methods: {
    sortQuestions(questions) {
      return questions.sort(function(a, b) {
        return a.sortOrder - b.sortOrder;
      });
    },
    // validateForm() {
    //   const initErrors = this.errors.length;

    //   if (!this.validateSurveyName()) {
    //     this.errors.push({ message: "Please enter a name of 5 or more characters." });
    //   }
    //   if (this.survey.questions.length == 0) {
    //     this.errors.push({ message: `You must include at least one question in this evaluation.` });
    //   }
    //   if (this.survey.questions.some(q => isNaN(q.sortOrder))){
    //     this.errors.push({ message: "Question order input must be a number" });
    //   } else if (this.survey.questions.some(q => q.sortOrder < 0)) {
    //     this.errors.push({ message: "Question order input must be greater than 0" });
    //   }

    //   return initErrors === this.errors.length;
    // },
    // validateSurveyName() {
    //   return this.survey.surveyName.length >= 5;
    // },
    // confirmDelete(modalId) {
    //   this.$root.$emit("bv::show::modal", modalId);
    // },
    removeQuestion(item) {
      let qidx = this.survey.questions.findIndex(q => q.questionId == item);
      if (qidx > -1) {
        this.survey.questions.splice(qidx, 1);
      }
    },
    setFormDirty() {
      this.sortQuestions(this.survey.questions);
    },
    showQuestionTemplateModal() {
      this.$root.$emit("bv::show::modal", "addQuestionTemplateModal");
      this.refreshQuestions(this.removeQuestionsAlreadyInList);
    },
    showNewQuestionModal() {
      this.$refs['new-question-modal'].show();
    },
    createQuestion() {
      
    },
    refreshQuestions(next) {
      axios
        .get(`${this.$api_url}/question-templates`, this.getReqConfig())
        .then(response => {
          this.questionTemplates = this.addIsCheckedToQuestionList(
            this.sortQuestionsList(response.data)
          );
        })
        // eslint-disable-next-line
        .then(r => {
          next();
        })
        .catch(err => {
          this.errors.push(err);
        });
    },
    sortQuestionsList(questions) {
      return questions.sort(function(a, b) {
        return a.text > b.text ? 1 : -1;
      });
    },
    removeQuestionsAlreadyInList: async function() {
      for (let q of this.survey.questions) {
        let idx = this.questionTemplates.findIndex(
          t => t.text === q.text
        );
        if (idx > -1) {
          this.questionTemplates.splice(idx, 1);
        }
      }
    },
    addIsCheckedToQuestionList(questionList) {
      for (let q of questionList) {
        q.isChecked = false;
      }
      return questionList;
    },
    addSafetyQuestions() {
      this.adjustQuestionsOrder(2);
      this.survey.questions.push({
        surveyId: null,
        questionId: null,
        text: "Have you actively incorporated any safety innovations on the project?",
        type: "Safety Innovation",
        required: false,
        commentTitle: "Safety Innovation",
        sortOrder: 0,
        answerOptions: [
        {
          answerOptionId: null,
          questionId: null,
          answerIndex: 'Yes',
          answerText: 'Yes',
          answerScore: -1,
          commentRequired: true
        },
        {
          answerOptionId: null,
          questionId: null,
          answerIndex: 'No',
          answerText: 'No',
          answerScore: -1,
          commentRequired: false
        }]
      });

      this.survey.questions.push({
        surveyId: null,
        questionId: null,
        text: "Do you have an idea that would improve worker safety?",
        type: "Safety Opportunity",
        required: false,
        commentTitle: "Safety Opportunity",
        sortOrder: 1,
        answerOptions: [
        {
          answerOptionId: null,
          questionId: null,
          answerIndex: 'Yes',
          answerText: 'Yes',
          answerScore: -1,
          commentRequired: true
        },
        {
          answerOptionId: null,
          questionId: null,
          answerIndex: 'No',
          answerText: 'No',
          answerScore: -1,
          commentRequired: false
        }]
      });

      this.sortQuestions(this.survey.questions);
    },
    removeSafetyQuestions() {
      this.survey.questions = this.survey.questions.filter(q => !this.isSafetyQuestion(q));
      this.adjustQuestionsOrder(0);
      this.sortQuestions(this.survey.questions);
    },
    navigateBackToSurveyList() {
      this.defaultRedirect();
    },
    isSafetyQuestion(question){
      return question.type === "Safety Innovation" || question.type === "Safety Opportunity";
    },
    adjustQuestionsOrder(startIndex){
      this.survey.questions.forEach(q => {
        q.sortOrder = startIndex++;
      });
    },
    showQuestionTypeModal() {
      this.$refs['question-type-modal'].show();
    },
    showOverviewTab() {
      this.$emit('showOverviewTab');
    },
    refreshSurveyTabAfterCreate(questions) {
      this.$emit('refreshSurveyTabAfterCreate', questions);
    }
  },
  computed: {
    uniqueErrors() {
      return Array.from(new Set(this.errors));
    },
    hasSafetyQuestions() {
      return this.survey.questions.some(q => q.type === "Safety Innovation") && this.survey.questions.some(q => q.type === "Safety Opportunity");
    },
    isMissingSurvey() {
      return this.survey.questions.length === 0;
    }
  }
};
</script>

<style scoped>
.bordered {
  border: #555 1px solid;
  border-radius: 5px;
  padding: 0.25em;
}
.bg-light-blue {
  background-color: rgb(221, 241, 248);
}
.modal-body {
  width: auto;
  height: auto;
  max-height: 70vh;
  overflow-y: auto;
}
.surveyTitle {
  font-size: 1.75em;
  line-height: 1em;
  color: #555;
}
</style>

